import { render, staticRenderFns } from "./NoDataHtml.vue?vue&type=template&id=6374bbcf&"
import script from "./NoDataHtml.vue?vue&type=script&lang=ts&"
export * from "./NoDataHtml.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports